<template>
  <PreviewElementWrapper 
    :initial-selected="isSelected"
    :elementType="element.type"
    :element="element"
    :selectedPreviewId="selectedPreviewId"
    :disabled="disabled"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @select-change="handleSelectChange"
    @update-element-data="handleWrapperDataUpdate"
    @auto-mapping = "(id)=>$emit('auto-mapping', id)"
    @element-edit-state-changed="({isEditing}) => handleWrapperEditStateChanged(isEditing)"
  >
    <div class="rating-scale">
      <!-- Left Label -->
      <div class="scale-label">
        <div v-if="!isEditingLeftLabel" class="scale-label-row">
          <div class="scale-label-wrapper left">
            <span class="scale-label">{{ currentLeftLabel }}</span>
          </div>
          <!-- Original: 
          <ActionButton
            v-if="!disabled && (isHovered || isSelected)"
            text="Edit"
            default-color="#374957"
            hover-text-color="#1E4670"
            pressed-text-color="#1E4670"
            hover-bg-color="rgba(30, 70, 112, 0.08)"
            pressed-bg-color="rgba(30, 70, 112, 0.12)"
            @click.stop="startLeftLabelEdit"
          >
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8969 3.16575C19.0892 3.45687 19.0571 3.85248 18.8008 4.10876L9.60845 13.3011C9.51422 13.3954 9.39659 13.4628 9.26766 13.4965L5.43923 14.4965C5.31437 14.5291 5.18566 14.5284 5.06473 14.4976C4.93616 14.4649 4.81639 14.3982 4.71937 14.3011C4.5311 14.1129 4.45676 13.8389 4.52405 13.5813L5.52405 9.75284C5.55351 9.64003 5.60881 9.52861 5.68529 9.44121L14.9117 0.21967C14.9925 0.138906 15.0898 0.0784602 15.1957 0.0416313C15.2742 0.0143243 15.3574 0 15.4421 0C15.641 0 15.8318 0.0790175 15.9724 0.21967L18.8008 3.0481C18.8374 3.08471 18.8695 3.12416 18.8969 3.16575ZM17.2098 3.57843L15.4421 1.81066L6.92391 10.3288L6.29893 12.7216L8.69169 12.0966L17.2098 3.57843Z" fill="#374957"/>
                <path d="M17.0834 14.9103C17.3568 12.5727 17.4438 10.2188 17.3444 7.87079C17.3397 7.75837 17.3819 7.64898 17.4615 7.56942L18.4448 6.58609C18.5657 6.46519 18.7723 6.54194 18.7836 6.71254C18.9685 9.50219 18.8984 12.3045 18.5733 15.0846C18.3367 17.1071 16.7124 18.6921 14.7003 18.917C11.2338 19.3044 7.65042 19.3044 4.18385 18.917C2.17179 18.6921 0.547457 17.1071 0.310903 15.0846C-0.103634 11.5403 -0.103635 7.95973 0.310903 4.41543C0.547456 2.3929 2.17179 0.807889 4.18385 0.583012C6.8136 0.289099 9.51054 0.218149 12.1727 0.370161C12.3443 0.379958 12.4225 0.587575 12.301 0.709093L11.3084 1.70165C11.2298 1.78034 11.1218 1.82261 11.0106 1.81885C8.78419 1.74376 6.54263 1.82872 4.35046 2.07373C3.02035 2.22239 1.95486 3.272 1.80075 4.58968C1.39975 8.01821 1.39975 11.4818 1.80075 14.9103C1.95486 16.228 3.02035 17.2776 4.35046 17.4263C7.70631 17.8013 11.1779 17.8013 14.5337 17.4263C15.8638 17.2776 16.9293 16.228 17.0834 14.9103Z" fill="#374957"/>
              </svg>
            </template>
          </ActionButton>
          -->
          <FoldableButton
            v-if="!disabled && (isHovered || isSelected)"
            text="Edit"
            built_in_theme="default"
            @click.stop="startLeftLabelEdit"
          >
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8969 3.16575C19.0892 3.45687 19.0571 3.85248 18.8008 4.10876L9.60845 13.3011C9.51422 13.3954 9.39659 13.4628 9.26766 13.4965L5.43923 14.4965C5.31437 14.5291 5.18566 14.5284 5.06473 14.4976C4.93616 14.4649 4.81639 14.3982 4.71937 14.3011C4.5311 14.1129 4.45676 13.8389 4.52405 13.5813L5.52405 9.75284C5.55351 9.64003 5.60881 9.52861 5.68529 9.44121L14.9117 0.21967C14.9925 0.138906 15.0898 0.0784602 15.1957 0.0416313C15.2742 0.0143243 15.3574 0 15.4421 0C15.641 0 15.8318 0.0790175 15.9724 0.21967L18.8008 3.0481C18.8374 3.08471 18.8695 3.12416 18.8969 3.16575ZM17.2098 3.57843L15.4421 1.81066L6.92391 10.3288L6.29893 12.7216L8.69169 12.0966L17.2098 3.57843Z" fill="#374957"/>
                <path d="M17.0834 14.9103C17.3568 12.5727 17.4438 10.2188 17.3444 7.87079C17.3397 7.75837 17.3819 7.64898 17.4615 7.56942L18.4448 6.58609C18.5657 6.46519 18.7723 6.54194 18.7836 6.71254C18.9685 9.50219 18.8984 12.3045 18.5733 15.0846C18.3367 17.1071 16.7124 18.6921 14.7003 18.917C11.2338 19.3044 7.65042 19.3044 4.18385 18.917C2.17179 18.6921 0.547457 17.1071 0.310903 15.0846C-0.103634 11.5403 -0.103635 7.95973 0.310903 4.41543C0.547456 2.3929 2.17179 0.807889 4.18385 0.583012C6.8136 0.289099 9.51054 0.218149 12.1727 0.370161C12.3443 0.379958 12.4225 0.587575 12.301 0.709093L11.3084 1.70165C11.2298 1.78034 11.1218 1.82261 11.0106 1.81885C8.78419 1.74376 6.54263 1.82872 4.35046 2.07373C3.02035 2.22239 1.95486 3.272 1.80075 4.58968C1.39975 8.01821 1.39975 11.4818 1.80075 14.9103C1.95486 16.228 3.02035 17.2776 4.35046 17.4263C7.70631 17.8013 11.1779 17.8013 14.5337 17.4263C15.8638 17.2776 16.9293 16.228 17.0834 14.9103Z" fill="#374957"/>
              </svg>
            </template>
          </FoldableButton>
        </div>
        <div v-else-if = "isEditingLeftLabel && (isHovered || isSelected)" class="label-edit-box">
          <input
            ref="leftLabelInput"
            v-model="currentLeftLabel"
            class="label-edit-input"
            @keyup.enter="saveLeftLabel"
            @keyup.esc="cancelLeftLabelEdit"
          />
          <TextButton
            @click.stop="saveLeftLabel"
          >
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M6.75012 12.1275L3.62262 9L2.55762 10.0575L6.75012 14.25L15.7501 5.25L14.6926 4.1925L6.75012 12.1275Z" fill="#1F1F1F"/>
              </svg>
            </template>
            Save
          </TextButton>
        </div>
      </div>
      <div class="scale-options">
        <div
          v-for="n in scaleSize"
          :key="n"
          class="scale-option"
        >
          <div class="radio-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#999999"/>
            </svg>
          </div>
        </div>
      </div>
      <!-- Right Label -->
      <div class="scale-label">
        <div v-if="!isEditingRightLabel" class="scale-label-row">
          <div class="scale-label-wrapper right">
            <span class="scale-label">{{ currentRightLabel }}</span>
          </div>
          <!-- Original:
          <ActionButton
            v-if="!disabled && (isHovered || isSelected)"
            text="Edit"
            default-color="#374957"
            hover-text-color="#1E4670"
            pressed-text-color="#1E4670"
            hover-bg-color="rgba(30, 70, 112, 0.08)"
            pressed-bg-color="rgba(30, 70, 112, 0.12)"
            @click.stop="startRightLabelEdit"
          >
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8969 3.16575C19.0892 3.45687 19.0571 3.85248 18.8008 4.10876L9.60845 13.3011C9.51422 13.3954 9.39659 13.4628 9.26766 13.4965L5.43923 14.4965C5.31437 14.5291 5.18566 14.5284 5.06473 14.4976C4.93616 14.4649 4.81639 14.3982 4.71937 14.3011C4.5311 14.1129 4.45676 13.8389 4.52405 13.5813L5.52405 9.75284C5.55351 9.64003 5.60881 9.52861 5.68529 9.44121L14.9117 0.21967C14.9925 0.138906 15.0898 0.0784602 15.1957 0.0416313C15.2742 0.0143243 15.3574 0 15.4421 0C15.641 0 15.8318 0.0790175 15.9724 0.21967L18.8008 3.0481C18.8374 3.08471 18.8695 3.12416 18.8969 3.16575ZM17.2098 3.57843L15.4421 1.81066L6.92391 10.3288L6.29893 12.7216L8.69169 12.0966L17.2098 3.57843Z" fill="#374957"/>
                <path d="M17.0834 14.9103C17.3568 12.5727 17.4438 10.2188 17.3444 7.87079C17.3397 7.75837 17.3819 7.64898 17.4615 7.56942L18.4448 6.58609C18.5657 6.46519 18.7723 6.54194 18.7836 6.71254C18.9685 9.50219 18.8984 12.3045 18.5733 15.0846C18.3367 17.1071 16.7124 18.6921 14.7003 18.917C11.2338 19.3044 7.65042 19.3044 4.18385 18.917C2.17179 18.6921 0.547457 17.1071 0.310903 15.0846C-0.103634 11.5403 -0.103635 7.95973 0.310903 4.41543C0.547456 2.3929 2.17179 0.807889 4.18385 0.583012C6.8136 0.289099 9.51054 0.218149 12.1727 0.370161C12.3443 0.379958 12.4225 0.587575 12.301 0.709093L11.3084 1.70165C11.2298 1.78034 11.1218 1.82261 11.0106 1.81885C8.78419 1.74376 6.54263 1.82872 4.35046 2.07373C3.02035 2.22239 1.95486 3.272 1.80075 4.58968C1.39975 8.01821 1.39975 11.4818 1.80075 14.9103C1.95486 16.228 3.02035 17.2776 4.35046 17.4263C7.70631 17.8013 11.1779 17.8013 14.5337 17.4263C15.8638 17.2776 16.9293 16.228 17.0834 14.9103Z" fill="#374957"/>
              </svg>
            </template>
          </ActionButton>
          -->
          <FoldableButton
            v-if="!disabled && (isHovered || isSelected)"
            text="Edit"
            built_in_theme="default"
            @click.stop="startRightLabelEdit"
          >
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8969 3.16575C19.0892 3.45687 19.0571 3.85248 18.8008 4.10876L9.60845 13.3011C9.51422 13.3954 9.39659 13.4628 9.26766 13.4965L5.43923 14.4965C5.31437 14.5291 5.18566 14.5284 5.06473 14.4976C4.93616 14.4649 4.81639 14.3982 4.71937 14.3011C4.5311 14.1129 4.45676 13.8389 4.52405 13.5813L5.52405 9.75284C5.55351 9.64003 5.60881 9.52861 5.68529 9.44121L14.9117 0.21967C14.9925 0.138906 15.0898 0.0784602 15.1957 0.0416313C15.2742 0.0143243 15.3574 0 15.4421 0C15.641 0 15.8318 0.0790175 15.9724 0.21967L18.8008 3.0481C18.8374 3.08471 18.8695 3.12416 18.8969 3.16575ZM17.2098 3.57843L15.4421 1.81066L6.92391 10.3288L6.29893 12.7216L8.69169 12.0966L17.2098 3.57843Z" fill="#374957"/>
                <path d="M17.0834 14.9103C17.3568 12.5727 17.4438 10.2188 17.3444 7.87079C17.3397 7.75837 17.3819 7.64898 17.4615 7.56942L18.4448 6.58609C18.5657 6.46519 18.7723 6.54194 18.7836 6.71254C18.9685 9.50219 18.8984 12.3045 18.5733 15.0846C18.3367 17.1071 16.7124 18.6921 14.7003 18.917C11.2338 19.3044 7.65042 19.3044 4.18385 18.917C2.17179 18.6921 0.547457 17.1071 0.310903 15.0846C-0.103634 11.5403 -0.103635 7.95973 0.310903 4.41543C0.547456 2.3929 2.17179 0.807889 4.18385 0.583012C6.8136 0.289099 9.51054 0.218149 12.1727 0.370161C12.3443 0.379958 12.4225 0.587575 12.301 0.709093L11.3084 1.70165C11.2298 1.78034 11.1218 1.82261 11.0106 1.81885C8.78419 1.74376 6.54263 1.82872 4.35046 2.07373C3.02035 2.22239 1.95486 3.272 1.80075 4.58968C1.39975 8.01821 1.39975 11.4818 1.80075 14.9103C1.95486 16.228 3.02035 17.2776 4.35046 17.4263C7.70631 17.8013 11.1779 17.8013 14.5337 17.4263C15.8638 17.2776 16.9293 16.228 17.0834 14.9103Z" fill="#374957"/>
              </svg>
            </template>
          </FoldableButton>
        </div>
        <div v-else-if="isEditingRightLabel && (isHovered || isSelected)" class="label-edit-box">
          <input
            ref="rightLabelInput"
            v-model="currentRightLabel"
            class="label-edit-input"
            @keyup.enter="saveRightLabel"
            @keyup.esc="cancelRightLabelEdit"
          />
          <TextButton
            @click.stop="saveRightLabel"
          >
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M6.75012 12.1275L3.62262 9L2.55762 10.0575L6.75012 14.25L15.7501 5.25L14.6926 4.1925L6.75012 12.1275Z" fill="#1F1F1F"/>
              </svg>
            </template>
            Save
          </TextButton>
        </div>
      </div>
    </div>
    <div class = "rating-scale-settings">
      <div class = "setting-row">
        <div class="setting-label">Scale Size (1 - {{ scaleSize }})</div>
        <div class="scale-size-selector">
          <SimpleSelector
            v-model:currentElementType="scaleSize"
            :elements="scaleSizeOptions"
          />
        </div>
      </div>
    </div>
  </PreviewElementWrapper>
</template>

<script>
import PreviewElementWrapper from './PreviewElementWrapper.vue';
// Original: import ActionButton from '@/views/commonComponents/ActionButton.vue';
// Replaced with globally registered FoldableButton from @vibrant-wellness/va-responsive-components-library
import SimpleSelector from '@/views/my-workbench-new/document-template/create-document/components/SimpleSelector.vue';
import TextButton from '@/views/commonComponents/TextButton.vue';

export default {
  name: 'RatingPreview',
  components: { PreviewElementWrapper, /* ActionButton, replaced by globally registered FoldableButton */ SimpleSelector, TextButton },
  props: {
    element: { type: Object, default: () => ({}) },
    selectedPreviewId: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    const elemData = (this.element && this.element.data) || {};
    return {
      scaleSize: elemData.scaleSize || 5,
      isHovered: false,
      isSelected: false,
      isEditingLeftLabel: false,
      isEditingRightLabel: false,
      currentLeftLabel: elemData.leftLabel || 'Lowest',
      currentRightLabel: elemData.rightLabel || 'Highest',
      scaleSizeOptions:[
        {label: '1', value: 1},
        {label: '2', value: 2},
        {label: '3', value: 3},
        {label: '4', value: 4},
        {label: '5', value: 5},
        {label: '6', value: 6},
        {label: '7', value: 7},
        {label: '8', value: 8},
        {label: '9', value: 9},
        {label: '10', value: 10}
      ],
      isWrapperEditing: false
    };
  },
  computed: {
    isElementEditing() {
      return this.isWrapperEditing || this.isEditingLeftLabel || this.isEditingRightLabel;
    }
  },
  emits: [
    'update-element-data',
    'auto-mapping',
    'element-edit-state-changed'
  ],
  watch: {
    scaleSize() {
      this.emitDataUpdate();
    },
    isElementEditing(newVal) {
      this.$emit('element-edit-state-changed', {
        id: this.element.id,
        isEditing: newVal
      });
    }
  },
  methods: {
    handleMouseEnter() {
      if (!this.disabled) {
        this.isHovered = true;
      }
    },
    handleMouseLeave() {
      this.isHovered = false;
    },
    handleWrapperEditStateChanged(isEditing) {
      this.isWrapperEditing = isEditing;
    },
    handleSelectChange(selected) {
      this.isSelected = selected;
      if(!selected) {
        if(this.isEditingLeftLabel){
          this.saveLeftLabel();
        }
        if(this.isEditingRightLabel){
          this.saveRightLabel();
        }
      }
    },
    startLeftLabelEdit() {
      if (this.disabled) {
        return;
      }
      this.isSelected = true;
      this.isEditingLeftLabel = true;
      this.$nextTick(() => {
        this.$refs.leftLabelInput?.focus();
        this.$refs.leftLabelInput?.select();
      });
    },
    startRightLabelEdit() {
      if (this.disabled) {
        return;
      }
      this.isSelected = true;
      this.isEditingRightLabel = true;
      this.$nextTick(() => {
        this.$refs.rightLabelInput?.focus();
        this.$refs.rightLabelInput?.select();
      });
    },
    cancelLeftLabelEdit() {
      const elementData = this.element.data || {};
      this.currentLeftLabel = elementData.leftLabel || '';
      this.isEditingLeftLabel = false;
    },
    cancelRightLabelEdit() {
      const elementData = this.element.data || {};
      this.currentRightLabel = elementData.rightLabel || '';
      this.isEditingRightLabel = false;
    },
    saveLeftLabel() {
      this.isEditingLeftLabel = false;
      this.emitDataUpdate();
    },
    saveRightLabel() {
      this.isEditingRightLabel = false;
      this.emitDataUpdate();
    },
    emitDataUpdate() {
      this.$emit('update-element-data', {
        scaleSize: this.scaleSize,
        leftLabel: this.currentLeftLabel,
        rightLabel: this.currentRightLabel
      });
    },
    handleWrapperDataUpdate(wrapperData) {
      this.$emit('update-element-data', {
        ...wrapperData,
        scaleSize: this.scaleSize,
        leftLabel: this.currentLeftLabel,
        rightLabel: this.currentRightLabel
      });
    }
  }
};
</script>

<style scoped>
.rating-scale {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
}

.scale-label-row{
  min-height: 24px;
  display: flex;
  align-items: center;  
  gap: 4px;
}

.scale-label-wrapper{
  flex:1;
  display: flex;
  align-items: center;
}

.scale-label-wrapper.left{
  justify-content: flex-end;
}

.scale-label-wrapper.right{
  justify-content: flex-start;
}

.scale-label {
  color: var(--color-Grey-Grey-4A, #4A4A4A);
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
}


/* Label editing box */
.label-edit-box {
  display: flex;
  align-items: center;
  background: white;
  border: 1px solid #C4C4C4;
  border-radius: 4px;
  padding: 3px 4px;
  gap: 4px;
  height: 26px;
  min-width: 0;

  width: 100%;
}

.label-edit-input {
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #666;
  min-width: 0;
}

:deep(.text-button) {
  padding: 1px 6px;
}

.scale-options {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.scale-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.radio-button {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
}

.radio-outer {
  width: 20px;
  height: 20px;
  border: 2px solid #004879;
  border-radius: 50%;
  background: #fff;
}

.option-number {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #333;
}

.setting-row{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.setting-label {
  flex: 1;
  font-family: 'Inter', sans-serif;
  color:  #4A4A4A;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
}

.scale-size-selector {
  min-width: 80px;
  width: 13%;
}
:deep(.selector-trigger){
  min-width: fit-content;
}
:deep(.dropdown-list){
  min-width: 100%;
}
</style>
